import { openConfirmPopup } from '@vlabs/uikit';
import i18next from 'i18next';

export const showResourceIntensiveTaskPopup = (onConfirm) => {
  openConfirmPopup({
    title: i18next.t('tasks:confirmation.resource_intensive_task.title'),
    message: i18next.t('tasks:confirmation.resource_intensive_task.message'),
    type: 'info',
    onConfirm,
  });
};
